export default {
  SET_PROPERTY(state, results) {
    state.property = results.data;
    console.log("SET_PROPERTY_M");
  },

  SET_PROPERTIES(state, response) {
    state.properties = response;
    console.log("SET_PROPERTIES");
  },

  SET_TEMPLATE(state, payload) {
    state.template = { ...state.template, ...payload };
  },

  UPDATE_VALIDATION(state, { step, isValid }) {
    state.validations[step] = isValid;
  },

  UPDATE_PROPERTY_ACCOMMODATION_UNIT(
    state,
    { unit_id, web_reservation_active }
  ) {
    if (state.property?.accommodation_units) {
      const unit = state.property.accommodation_units.find(
        (u) => u.id === unit_id
      );
      if (unit) {
        unit.web_reservation_active = web_reservation_active;
      }
    }
  },

  UPDATE_PROPERTIES_ACCOMMODATION_UNIT(
    state,
    { property_id, unit_id, web_reservation_active }
  ) {
    const property = state.properties.find((p) => p.id === property_id);
    if (property?.accommodation_units) {
      const unit = property.accommodation_units.find((u) => u.id === unit_id);
      if (unit) {
        unit.web_reservation_active = web_reservation_active;
      }
    }
  },
};